import { jobsConstants } from "../../_constants";
import axiosInstance from "../../../_helpers/axiosInstance";
import config from "../../../_config/config";
import {
  showSuccessMessage,
  showWarningMessage,
} from "../../../_uiComponents/ShowMessageSnack";

//schedule interview
export const get_shared_job_detail_action = (id) => async (dispatch) => {
  dispatch({
    type: jobsConstants.GET_SHARED_JOB_DETAIL_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      `${config.common.jobDetail.replace(":id", id)}`
    );
    if (response.status) {
      dispatch({
        type: jobsConstants.GET_SHARED_JOB_DETAIL_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: jobsConstants.GET_SHARED_JOB_DETAIL_ACTION_FAILURE,
      payload: e.msg,
    });
  }
};

//get all jobs
export const get_all_jobs_user_action = (page) => async (dispatch) => {
  dispatch({
    type: jobsConstants.GET_ALL_JOBS_USER_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      `${config.common.allJobs}?page=${page ? page : 1}`
    );
    if (response.status) {
      dispatch({
        type: jobsConstants.GET_ALL_JOBS_USER_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: jobsConstants.GET_ALL_JOBS_USER_ACTION_FAILURE,
      payload: e.msg,
    });
  }
};

//get job details
export const get_job_details_user_action = (id) => async (dispatch) => {
  dispatch({
    type: jobsConstants.GET_JOB_DETAILS_USER_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      config.common.jobDetail.replace(":id", id)
    );
    if (response.status) {
      dispatch({
        type: jobsConstants.GET_JOB_DETAILS_USER_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: jobsConstants.GET_JOB_DETAILS_USER_ACTION_FAILURE,
      payload: e.msg,
    });
  }
};

//get job details
export const invite_user_to_job_action = (data) => async (dispatch) => {
  dispatch({
    type: jobsConstants.INVITE_USER_TO_JOB_REQUEST,
  });
  try {
    const response = await axiosInstance.post(
      config.common.inviteUserToJob,
      data
    );
    if (response.status) {
      dispatch({
        type: jobsConstants.INVITE_USER_TO_JOB_SUCCESS,
        payload: response.data,
      });
      showSuccessMessage("User successfully invited to job");
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    showWarningMessage("User already invited");
    dispatch({
      type: jobsConstants.INVITE_USER_TO_JOB_FAILURE,
      payload: e.msg,
    });
  }
};

export const get_invited_jobs_user_action = (data) => async (dispatch) => {
  dispatch({
    type: jobsConstants.GET_INVITED_JOBS_USER_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(config.common.invitedJobsList);
    if (response.status) {
      dispatch({
        type: jobsConstants.GET_INVITED_JOBS_USER_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    showWarningMessage(e?.msg);
    dispatch({
      type: jobsConstants.GET_INVITED_JOBS_USER_ACTION_FAILURE,
      payload: e.msg,
    });
  }
};

export const assign_event_to_job_action = (data) => async (dispatch) => {
  dispatch({
    type: jobsConstants.ASSIGN_EVENT_TO_JOB_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(
      config.common.assignEventToJob,
      data
    );
    if (response.status) {
      dispatch({
        type: jobsConstants.ASSIGN_EVENT_TO_JOB_ACTION_SUCCESS,
        payload: response.data,
      });
      showSuccessMessage("Event is assigned to job");
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    // showWarningMessage("User already invited");
    dispatch({
      type: jobsConstants.ASSIGN_EVENT_TO_JOB_ACTION_FAILURE,
      payload: e.msg,
    });
  }
};

export const send_interview_invitation_to_candidate_action =
  (data) => async (dispatch) => {
    dispatch({
      type: jobsConstants.SEND_INTERVIEW_INVITATION_TO_CANDIDATE_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        config.common.sendInterviewInvitationToCandidate,
        data
      );
      if (response.status) {
        dispatch({
          type: jobsConstants.SEND_INTERVIEW_INVITATION_TO_CANDIDATE_ACTION_SUCCESS,
          payload: response.data,
        });
        showSuccessMessage("User successfully invited to job");
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      showWarningMessage("User already invited");
      dispatch({
        type: jobsConstants.SEND_INTERVIEW_INVITATION_TO_CANDIDATE_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };
